require("core-js/modules/es.array.join");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.manualInput = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: 'XiazengManualInput',
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        codeList: []
      };
    },
    created: function created() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.codeInput && _this.$refs.codeInput.focus();
      });
    },
    methods: {
      // 监听输入
      watchInput: function watchInput(e) {
        var val = e.target.value.replace(/\D/g, '').slice(0, 8);
        e.target.value = val;
        this.codeList = val ? val.split('') : [];
      },
      // 点击输入框聚焦
      tapCode: function tapCode() {
        this.$refs.codeInput && this.$refs.codeInput.focus();
      },
      // 确认手动输入的编号
      onclickNextBtn: function onclickNextBtn() {
        var vm = this;
        var code = vm.codeList.join('');
        if (code.length !== 8) return;
        vm.confirmId(code);
      },
      // 确认编号，回传给上一页并返回
      confirmId: function confirmId(uniqueId) {
        // 先存储到 sessionStorage，再返回上一步
        sessionStorage.setItem('xiazengManualUniqueId', uniqueId);
        this.$router.back();
      },
      // 返回扫码页面
      onclickCancelManual: function onclickCancelManual() {
        this.$router.back();
      }
    }
  };
  _exports.default = _default;
});